import './RoundRobinGrid.css'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const RoundRobinGrid = (props) => {
	const { t } = useTranslation()
	// Получаем объединенный массив для таблицы Сетка
	const [grid, setGrid] = useState([])
	const [gridResults, setGridResults] = useState([])

	// useEffect для таблицы Сетка
	useEffect(() => {
		if (Object.keys(props.group).length !== 0) {
			// Получаем имена игроков по группам
			const gridArr = props.group.nodes.flatMap(node => {
				let playerObject
		
				if (node.type === 'incoming') {
					if (node.double_uid === null && node.player_uid === null) {
						// Если нет double_uid и player_uid
						return node
					} else if (props.tournamentState.players !== null) {
						// Одиночный
						playerObject = props.tournamentState.players.find(player => player.uid === node.player_uid)
					} else {
						// Парный
						playerObject = props.tournamentState.doubles.find(doublesPlayer => doublesPlayer.uid === node.double_uid)
					}
		
					if (playerObject) {
						// Возвращаем объект с установленным nodeUid
						return {
							...playerObject,
							nodeUid: node?.uid
						}
					}
				}
		
				return null // Возвращаем null для элементов, которые не прошли фильтр
			}).filter(player => player !== null)

			// Получаем все результаты игр по группам
			const gridResultArr = props.group.results.map((result) => {
				return result
			})

			setGrid(gridArr)
			setGridResults(gridResultArr)
		}
		else {
			return
		}
	}, [props.tournamentState, props.group])

	// Получаем ноды группы
	function getNodes() {
		const nodesMap = new Map()

		props?.group.nodes.forEach(node => {
			nodesMap.set(node.uid, node)
		})

		return nodesMap
	}

	// Возвращает всех игроков по их uid
	function getPlayerUid(index) {
		const nodes = getNodes()

		return [...nodes.keys()][index]
	}

	// Возвращаем матчи и инвертируем их по необходимости
	function getMatchPlusInverted(index1, index2) {
		const matches = props?.group?.matches
		let inverted = Boolean
		let foundMatch = []

		foundMatch = matches.filter(match =>
			match.side2_uid === getPlayerUid(index1) && match.side1_uid === getPlayerUid(index2)
		)

		if (foundMatch.length === 0) {
			// Если ничего не нашли, то мы проверям повторно, но инвертировав index1 и index2
			foundMatch = matches.filter(match =>
				match.side1_uid === getPlayerUid(index1) && match.side2_uid === getPlayerUid(index2)
			)

			if (foundMatch.length !== 0) {
				// Если мы инвертировав нашли нужный нам элемент, то указываем в inverted = true
				inverted = true
			} else {
				// Если не смогли получить сеты игроков, то вызываем функцию goToMatch которая возвращает 0:0
				inverted = false

				return [
					matches,
					inverted
				]
			}
		} else {
			// Если нашли, то указываем в inverted = false
			inverted = false
		}

		return [
			foundMatch,
			inverted
		]
	}

	const defineAvailablityOfPlayer = (player) => {
		if (props?.tournamentState?.type === 'singles') {
			return {
				...player,
				available: player?.formedName ? true : false
			}
		} else {
			return {
				...player,
				available: player?.player1 ? true : false
			}
		}
	}

	// Вызываем внутри таблицы для получения матчей
	function getMatch(index1, index2, playerOne, playerTwo) {
		const updatedPlayerOne = defineAvailablityOfPlayer(playerOne)
		const updatedPlayerTwo = defineAvailablityOfPlayer(playerTwo)

		const [matches, inverted] = getMatchPlusInverted(index1, index2)
		return setString(matches, inverted, updatedPlayerOne, updatedPlayerTwo)
	}

	const formMatch = (match, participantOne, participantTwo) => {
		let matchWithPlayers = {}

		if (props?.tournamentState?.type === 'singles') {
			matchWithPlayers = {
				...match,
				side1: {
					namePlayer: participantOne?.formedName,
					nodeUid: participantOne?.nodeUid
				},
				side2: {
					namePlayer: participantTwo?.formedName,
					nodeUid: participantTwo?.nodeUid
				}
			}
		} else {
			matchWithPlayers = {
				...match,
				side1: {
					namePlayer1: participantOne?.player1?.formedName,
					namePlayer2: participantOne?.player2?.formedName,
					nodeUid: participantOne?.nodeUid
				},
				side2: {
					namePlayer1: participantTwo?.player1?.formedName,
					namePlayer2: participantTwo?.player2?.formedName,
					nodeUid: participantTwo?.nodeUid
				}
			}
		}

		return matchWithPlayers
	}

	const openMatch = (match, playerOne, playerTwo) => {
		if (!props?.auth) {
			return
		}

		if (!playerOne?.available || !playerTwo?.available) {
			return
		}

		const matchWithPlayers = formMatch(match, playerOne, playerTwo)
		props?.sendMatchData(matchWithPlayers)
		sessionStorage.setItem('activatedComponent', 'match')
		sessionStorage.setItem('match', JSON.stringify(matchWithPlayers))
	}

	// Формируем данные для таблицы
	function setString(matches, inverted, playerOne, playerTwo) {
		// Получаем все сеты у всех матчей
		const sets = matches.map(match => {
			return match.sets
		}).flat()

		// Проверяем, если сетов нет
		if (sets.length === 0) {
			return (
				<div>
					{
						matches?.map((match, matchIndex) => {
							return (
								<p key={matchIndex} onClick={() => openMatch(match, playerOne, playerTwo)}>
									<span>
										0:0
									</span>
								</p>
							)
						})
					}
				</div>
			)
		} else {
			// Если сеты есть
			return (
				<div>
					{
						matches?.map((match) => {
							return match.sets.map((set, setIndex) => {
								const tieBreakScore1 = set.tie_break_score1 ? set.tie_break_score1.toString() : ''
								const tieBreakScore2 = set.tie_break_score2 ? set.tie_break_score2.toString() : ''

								if (inverted) {
									return (
										<p key={setIndex} onClick={() => openMatch(match, playerOne, playerTwo)}>
											<span>
												{set.score1}
												<sup>
													{tieBreakScore1}
												</sup>
												:
												{set.score2}
												<sup>
													{tieBreakScore2}
												</sup>
											</span>
										</p>
									)
								} else {
									return (
										<p
											key={setIndex}
											onClick={() => openMatch(match, playerOne, playerTwo)}
										>
											<span>
												{set.score2}
												<sup>
													{tieBreakScore2}
												</sup>
												:
												{set.score1}
												<sup>
													{tieBreakScore1}
												</sup>
											</span>
										</p>
									)
								}
							})
						})
					}
				</div>
			)
		}
	}

	return (
		<>
			<div className="roundrobin-grid__container">
				<p className="roundrobin-grid__title">
					{t('Group')} {props?.group?.name}
				</p>
			</div>

			<div className="roundrobin-grid__wrapper">
				<div className="roundrobin-grid__sheet">
					<div className="roundrobin-grid__content">
						<div className="roundrobin-grid__row">
							<div className="roundrobin-grid__header">
								№
							</div>

							<div className="roundrobin-grid__header">
								{t('Players')}
							</div>

							{
								grid?.map((grid, index) => {
									return (
										<div className="roundrobin-grid__header" key={index}>{index + 1}</div>
									)
								})
							}

							<div className="roundrobin-grid__header">M</div>
							<div className="roundrobin-grid__header">S</div>
							<div className="roundrobin-grid__header">G</div>
							<div className="roundrobin-grid__header">R</div>
						</div>

						{
							grid?.map((itemVer, indexVertical) => {
								return (
									<div className="roundrobin-grid__row" key={indexVertical}>
										<div className="roundrobin-grid__cell">
											{indexVertical + 1}
										</div>

										{
											itemVer.player1 ?
												// Парный
												<div className="roundrobin-grid__cell">
													{
														itemVer.player1?.formedName ?
															`${itemVer.player1?.formedName} / ${itemVer.player2?.formedName}`
															:
															itemVer.name
													}
												</div>
												:
												// Одиночный
												<div className="roundrobin-grid__cell">
													{
														itemVer?.formedName ?
															`${itemVer?.formedName}`
															:
															itemVer?.name
													}
												</div>
										}

										{
											grid?.map((itemHor, indexHorizontally) =>
												<div
													className={
														`roundrobin-grid__cell ${indexVertical === indexHorizontally ?
															'roundrobin-grid__cell--grey'
															:
															''
														}`
													}
													key={indexHorizontally}
												>
													{
														indexVertical === indexHorizontally ?
															''
															:
															getMatch(indexVertical, indexHorizontally, itemVer, itemHor)
													}
												</div>
											)
										}

										<div className="roundrobin-grid__cell">
											{gridResults[indexVertical]?.match_points_won} – {gridResults[indexVertical]?.match_points_lost}
										</div>
										<div className="roundrobin-grid__cell">
											{gridResults[indexVertical]?.set_points_won} – {gridResults[indexVertical]?.set_points_lost}
										</div>
										<div className="roundrobin-grid__cell">
											{gridResults[indexVertical]?.game_points_won} – {gridResults[indexVertical]?.game_points_lost}
										</div>
										<div className="roundrobin-grid__cell">
											{gridResults[indexVertical]?.ranking}
										</div>
									</div>
								)
							})
						}
					</div>
				</div>
			</div>
		</>
	)
}

export default RoundRobinGrid